<template>
  <div class="profile-card">
    <!-- The profile card is the way to Mitt konto. -->
    <router-link
      :to="$routes.EDIT_PROFILE"
      class="user-card"
      :aria-label="$t('tab_bar_my_account')"
      @click.native="handleClick"
    >
      <ProfileAvatar class="user-avatar" :size="50" :avatar="user.avatar" />
      <div class="user-info-box">
        <span class="user-card-title">{{ $t('menu_user_card_account') }}</span>
        <span class="user-card-meta">{{ user.name }}</span>
      </div>
      <MenuIcon icon="chevron" class="user-card-chevron" />
    </router-link>

    <!-- Your own last active, response rate and response time, as others
         see them on your ad. -->
    <UserActivityDetails
      v-if="primaryPropositionId"
      in-menu
      :proposition-id="String(primaryPropositionId)"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProfileAvatar from '../Icons/ProfileAvatar';
import MenuIcon from '../Icons/MenuIcon';
import UserActivityDetails from '../Proposition/UserCard/UserActivityDetails.vue';

export default {
  name: 'UserCard',

  components: {
    ProfileAvatar,
    MenuIcon,
    UserActivityDetails
  },

  computed: {
    ...mapGetters({
      user: 'app/user',
      primaryPropositionId: 'myPropositions/primaryPropositionId'
    })
  },

  methods: {
    ...mapActions({
      closeMenu: 'menu/closeMenu'
    }),

    // On Mitt konto already the router does not navigate, and the menu only
    // closes on navigation: close it here and show the page from the top.
    handleClick() {
      if (this.$route.path !== this.$routes.EDIT_PROFILE) return;
      this.closeMenu();
      window.scrollTo(0, 0);
    }
  }
};
</script>

<style lang="scss" scoped>
// A white card of its own at the top of the menu, like the app.
.profile-card {
  box-sizing: border-box;
  width: calc(100% - 24px);
  margin: 12px 12px 0;
  border-radius: $card-radius;
  background-color: var(--Surface-White);
}

.user-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
  border-radius: $card-radius;
  color: var(--Text-Primary);
  text-decoration: none;

  // Hovering keeps the colour and makes the chevron bolder and darker.
  @media (hover: hover) {
    &:hover .user-card-chevron {
      stroke-width: 2.5px;
      opacity: 1;
    }
  }

  &:focus-visible {
    outline: 2px solid var(--Primary-Color);
    outline-offset: 2px;
  }
}

.user-avatar {
  flex-shrink: 0;
}

.user-info-box {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.user-card-title {
  font-size: 15px;
  font-weight: 600;
}

.user-card-meta {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: var(--Text-Secondary);
}

.user-card-chevron {
  flex-shrink: 0;
  opacity: 0.4;
  transition: stroke-width 0.1s ease-out, opacity 0.1s ease-out;
}
</style>
